import { Button, Col, Row } from 'antd';
import React from 'react';
import { motion } from 'framer-motion';
import { useHistory } from 'react-router-dom';
import checked from '../assets/images/checked-bullet.svg';
import ATlogo1 from '../assets/images/AT PPD Blue - White v2.webp';
import ship from '../assets/images/AP-ship.webp';
import shop from '../assets/images/shop-image.webp';
import rightArrow from '../assets/images/right-arrow 10.svg';
import { MENU } from '../../../AppConstants';
import { useDispatch } from 'react-redux';

const { TOGGLE_AP_CROSSING } = MENU;
const imagePaths = {
  exotic: require('../assets/images/Exotic-image.webp'),
  specimen: require('../assets/images/specimen-image.webp'),
  thailand: require('../assets/images/Europe-image.webp'),
  europe: require('../assets/images/Thailand-image.webp'),
  pleasure: require('../assets/images/Pleasure-lake-image.webp'),
  appLake: require('../assets/images/app-lake-placeholder.webp'),
  checked: require('../assets/images/checked-bullet.svg').default,
  appQR: require('../assets/images/AppDownload.svg').default,
  appStoreIcon:
    require('../../common/assets/images/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg')
      .default,
  googlePlayIcon: require('../../common/assets/images/google-play-badge.png'),
};

const variantLeft = {
  visible: {
    x: 0,
    transition: {
      type: 'ease',

      duration: 0.8,
    },
  },
  hidden: { x: '-100vw' },
};
const variantRight = {
  visible: {
    x: 0,
    transition: {
      type: 'ease',

      duration: 0.8,
    },
  },
  hidden: { x: '100vw', visible: '' },
};

function HomePageVenueContent() {
  const history = useHistory();
  const dispatch = useDispatch();
  const tileData = [
    {
      title: (
        <div className='fs-28 gBold'>
          Cheaper <span className='gMedium sb-blue-100'>crossings?</span> <br />
          Yes Please…
        </div>
      ),
      description: (
        <div className='fs-20 gMedium'>
          We can help <span className='gBold'>save on your next crossing</span>{' '}
          to Europe
        </div>
      ),
      click: () => {
        dispatch({
          type: TOGGLE_AP_CROSSING,
          showCrossingDrawer: true,
        });
      },
      img: ship, // replace with actual image path
    },
    {
      title: (
        <div className='fs-28 gBold'>
          Tackle, Bait, Gear? <br />
          <span className='gMedium sb-blue-100'>We’ve got you covered.</span>
        </div>
      ),
      description: (
        <div className='fs-20 gMedium'>
          Find <span className='gBold'>great deals</span> in the swimbooker shop
        </div>
      ),
      click: () => {
        window.open('https://shop.swimbooker.com/', '_blank');
      },
      img: shop, // replace with actual image path
    },
  ];
  return (
    <div>
      <motion.div
        initial='hidden'
        whileInView='visible'
        viewport={{ once: true, amount: 0.3 }}
        className='row-center justify-between  home-angling-trust-container'
      >
        <motion.div className='home_AT_details' variants={variantLeft}>
          <div
            className='  sb-blue-700 gBold txt-center mg-bottom-20 w-fit'
            style={{
              border: '2px solid #2772AF',
              borderRadius: 50,
              padding: '3px 15px',
            }}
          >
            We are the Official Events Booking Partner of The Angling Trust
          </div>
          <div className='fs-36 gBold grey-900'>The Event Marketplace</div>
          <div className='fs-18 gSemiBold sb-grey-800 mg-bottom-20'>
            We’ve developed the industry’s first nationwide coaching & event
            platform for angling
          </div>
          <div className='mg-bottom-30'>
            <div className='mg-bottom-15 fs-16 gMedium row-center'>
              <img
                src={checked}
                alt='checked'
                width={23}
                className='mg-right-10'
              />
              Easy access to certified coaches and events
            </div>
            <div className='mg-bottom-15 fs-16 gMedium row-center'>
              <img
                src={checked}
                alt='checked'
                width={23}
                className='mg-right-10'
              />
              A comprehensive solution for coaches and education providers
            </div>
            <div className='mg-bottom-15 fs-16 gMedium row-center'>
              <img
                src={checked}
                alt='checked'
                width={23}
                className='mg-right-10'
              />
              Protecting the anglers and event organisers with industry best
              practices
            </div>
          </div>
          <div className='row-center gap-2r flex-wrap home-events-buttons'>
            <Button
              className=' sb-blue-bg-600 hover:sb-blue-bg-700 white pd-10 fs-18 gBold h-full center'
              style={{
                width: '100%',
                maxWidth: 340,
                borderRadius: 50,
              }}
              onClick={() => {
                history.push('/events/search');
              }}
            >
              {' '}
              View all Events
            </Button>
            <div
              className='fs-18 gBold grey-800 hover:grey-900 txt-underline cp'
              onClick={() => {
                history.push('/event/signup');
              }}
            >
              Create Free Coach Account
            </div>
          </div>
        </motion.div>
        <motion.div variants={variantRight} className='center justify-center'>
          <img
            src={ATlogo1}
            alt='Angling Trust'
            width={275}
            height={268}
            loading='lazy'
          />
        </motion.div>
      </motion.div>
      <div className=' mg-bottom-40'>
        <div className='fs-38 gSemiBold sb-blue-900'>
          Adding Value{' '}
          <span className='sb-blue-800 gBold'> To Your Angling</span>
        </div>
        <div className='grey-700 gMedium fs-20 mg-bottom-15'>
          Consider using our added services to save money on travel and gear
        </div>
      </div>
      <Row gutter={[20, 20]} className='mg-bottom-30'>
        {tileData.map((tile, idx) => (
          <Col xs={24} md={12} key={idx}>
            <div
              className='white AP-home-container cp h-full justify-between br20 row-center'
              style={{
                position: 'relative',
                backgroundImage: `url(${tile.img})`,
              }}
              onClick={tile?.click}
            >
              <div
                className='br20 w-full h-full'
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  backgroundColor: 'rgba(0, 0, 0, 0.50)',
                  zIndex: 1,
                }}
              />

              <div
                className='br30 white gBold  ap-crossing-new fs-12 justify-center center'
                style={{
                  position: 'absolute',
                  top: -12,
                  right: 35,
                  zIndex: 2,
                }}
              >
                NEW
              </div>
              <div
                className='h-full  justify-between'
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  flex: 1,
                  zIndex: 2,
                }}
              >
                <div style={{ fontSize: 22, lineHeight: 1.3 }}>
                  {tile.title}
                </div>

                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginTop: 24,
                  }}
                >
                  <div style={{ fontSize: 16 }}>{tile.description}</div>
                </div>
              </div>
              <img src={rightArrow} alt='' width={23} style={{ zIndex: 2 }} />
            </div>
          </Col>
        ))}
      </Row>
      <div>
        <div className='fs-38 gSemiBold sb-blue-800'>
          Find Your <span className='sb-blue-900 gBold'> Perfect Venue!</span>
        </div>
        <div className='grey-700 gMedium fs-20 mg-bottom-15'>
          swimbooker is the perfect place to book your next session or holiday.
        </div>
        <Row gutter={[40, 40]} className='mg-bottom-20'>
          <Col span={24} md={12}>
            <div
              className='venue-type-container cp'
              onClick={() =>
                history.push(`/search`, {
                  homeFilter: '10a7a430-d2e0-4b2c-8284-1dcb4b5eeeb7',
                })
              }
            >
              <div className='text-container'>Explore Lodge Stays</div>
              <img src={imagePaths.exotic} alt='' loading='lazy' />
            </div>
          </Col>
          <Col span={24} md={12}>
            <div
              className='venue-type-container cp'
              onClick={() =>
                history.push(`/search`, {
                  homeFilter: 'd778fd21-187e-406a-9615-c54362d67054',
                })
              }
            >
              <div className='text-container'>Explore Specimen Waters</div>
              <img src={imagePaths.specimen} alt='' loading='lazy' />
            </div>
          </Col>
          <Col span={24} md={8}>
            <div
              className='venue-type-container cp'
              onClick={() =>
                window.open('https://holidays.swimbooker.com/', '_blank')
              }
            >
              <img src={imagePaths.europe} alt='' loading='lazy' />
              <div className='grey-700 fs-16 gMedium mg-top-10'>On Tour</div>
              <div className='grey-900 fs-16 gBold'>
                Fishing Holidays in Europe
              </div>
            </div>
          </Col>

          <Col span={24} md={8}>
            <div
              className='venue-type-container cp'
              onClick={() =>
                history.push(`/search`, {
                  homeFilter: '7ab79dbc-94a6-4b65-a559-dd5a5b0419cd',
                })
              }
            >
              <img src={imagePaths.thailand} alt='' loading='lazy' />
              <div className='grey-700 fs-16 gMedium mg-top-10'>
                Further Afield
              </div>
              <div className='grey-900 fs-16 gBold'>
                Fishing Holidays in Thailand
              </div>
            </div>
          </Col>
          <Col span={24} md={8}>
            <div
              className='venue-type-container cp'
              onClick={() =>
                history.push(`/search`, {
                  homeFilter: '158a113c-751d-430a-bff7-fb15d041a04b',
                })
              }
            >
              <img src={imagePaths.pleasure} alt='' loading='lazy' />
              <div className='grey-700 fs-16 gMedium mg-top-10'>
                Family Day Out
              </div>
              <div className='grey-900 fs-16 gBold'>
                Explore Family Friendly Lakes
              </div>
            </div>
          </Col>
          <Col span={24}>
            <Row className='mobile-app-container'>
              <div className='img-container'>
                <img
                  src={imagePaths.appLake}
                  alt='Lake view in the swimbooker app'
                  loading='lazy'
                />
              </div>
              <div
                className='  justify-between'
                style={{
                  flex: 1,
                  flexDirection: 'column',
                  padding: '20px 20px 15px ',
                }}
              >
                <div className='row-center flex-wrap'>
                  <div className='benefits'>
                    <div className='fs-32 grey-900 gBold mg-bottom-20 text-center'>
                      Go further with the swimbooker app
                    </div>
                    <div>
                      <div className='fs-18 gSemiBold grey-800 mg-bottom-15'>
                        <img
                          src={imagePaths.checked}
                          alt='checked'
                          className='mg-right-15'
                        />
                        Direct Notification Updates
                      </div>
                      <div className='fs-18 gSemiBold grey-800 mg-bottom-15'>
                        <img
                          src={imagePaths.checked}
                          alt='checked'
                          className='mg-right-15'
                        />
                        MySB - Your Angler Hub
                      </div>
                      <div className='fs-18 gSemiBold grey-800 mg-bottom-15'>
                        <img
                          src={imagePaths.checked}
                          alt='checked'
                          className='mg-right-15'
                        />
                        Advanced Catch Reports
                      </div>
                      <div className='fs-18 gSemiBold grey-800 mg-bottom-15'>
                        <img
                          src={imagePaths.checked}
                          alt='checked'
                          className='mg-right-15'
                        />
                        Live Availability
                      </div>
                    </div>
                  </div>
                  <div className='QR'>
                    <img src={imagePaths.appQR} alt='app-qr' />
                  </div>
                  <div className='app-mobile-icons'>
                    <a
                      href={
                        'https://apps.apple.com/gb/app/swimbooker/id1586855906'
                      }
                      className={'sb-footer__app_link'}
                    >
                      <img
                        src={imagePaths.appStoreIcon}
                        alt={'Download on the App Store'}
                      />
                    </a>
                    <a
                      className={'sb-footer__app_link'}
                      href='https://play.google.com/store/apps/details?id=com.app.swimbookerapp&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'
                    >
                      <img
                        src={imagePaths.googlePlayIcon}
                        alt='Get it on Google Play'
                      />
                    </a>
                  </div>
                </div>
                <div className='gSemiBold fs-20 grey-900 text'>
                  Scan the QR code with your device camera and download our app
                </div>
              </div>
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default HomePageVenueContent;
